<template>
  <!-- 导览 -->
  <div class="guide-wrapper w-100">
    <!-- 列表头部 -->
    <div class="com-list-header">
      <el-form class="com-search-box" :model="form" ref="form" label-width="80px">
        <el-row>
          <el-col :span="6">
            <el-form-item>
              <el-input v-model="form.name" placeholder="请输入关键字"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="com-head-search-btns">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="resetForm()">重置</el-button>
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="button">
        <el-row>
          <el-button class="el-primary-border" round @click="handleAdd('add')">
            <svg-icon icon-class="add" />&nbsp;添加导览
          </el-button>
        </el-row>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData">
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column>
          <el-table-column prop="name" label="导览名称" show-overflow-tooltip>
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="guide(scope.row)">{{scope.row.name}}</a>
            </template>
          </el-table-column>

          <el-table-column prop="sequence" label="导览顺序">
          </el-table-column>

          <!-- 操作 -->
          <el-table-column fixed="right" label="操作">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="guide(scope.row)">导览管理</a>
              <a class="m-btn mr-10" @click="handleView(scope.row)">查看</a>
              <a class="m-btn mr-10" @click="handleEdit(scope.row)">编辑</a>
              <a class="m-btn mr-10 m-danger" @click="handleDelete(scope.row)">删除</a>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background
            layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <!-- 新增 -->
    <div>
      <el-dialog title="导览管理" @close="onCancel"
        :close-on-click-modal="false" :visible.sync="dialogVisible" :width="'600px'">
        <el-form ref="form" :model="addForm" :rules="rules">
          <el-form-item class="mb-30" prop="name">
            <el-input v-model="addForm.name" :disabled="operation == 'view'" placeholder="请输入导览名称" />
          </el-form-item>
          <el-form-item class="mb-30" prop="sequence">
            <el-input v-model="addForm.sequence" :disabled="operation == 'view'" placeholder="请输入导览顺序" />
          </el-form-item>
          <el-form-item class="avatar-uploader-form" prop="pic">
            <el-upload class="avatar-uploader" v-model="addForm.pic" action="/singleMuseum/attach/upload"
              :disabled="operation == 'view'" accept=".jpg,.jpeg,.png,.JPG" :data="configData" :show-file-list="false"
              :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
              <img v-if="imgUrl" style="height:120px;object-fit:contain;" :src="imgUrl" class="avatar">
              <div v-else>
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <div class="el-upload__text">上传导览封面</div>
              </div>
            </el-upload>
            <div class="tip-img">建议图片大小：978 * 900</div>
            <!-- <div class="uploader-form" @click="uploadPicture()">
              <img v-if="imgUrl" :src="imgUrl" alt="">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </div>

            <div class="tip-img">建议图片大小：315 * 250</div> -->

          </el-form-item>
        </el-form>
        <div class="dialog-footer tr mt-30" v-if="operation != 'view'">
          <el-button @click="onCancel">取 消</el-button>
          <el-button type="primary" @click="onSubmit()">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 剪裁组件弹窗 -->
    <!-- <cropper-image ref="cropperRef" @uploadImgSuccess="handleAvatarSuccess">
    </cropper-image> -->
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import CropperImage from "@cmp/cropper";

export default {
  components: {
    CropperImage,
  },
  computed: {
    ...mapGetters(['imageTypes']),
  },
  data() {
    return {
      form: {
        name: '',
      },
      operation: 'add',
      addForm: {},
      rules: {
        name: [{ required: true, message: '导览名称不能为空', trigger: 'blur' }],
        pic: [{ required: true, message: '导览封面不能为空', trigger: 'change' }],
        sequence: [{ required: true, message: '导览顺序不能为空', trigger: 'change' }],
      },
      configData: {
        tableName: 'collect'
      },
      imgUrl: "",
      listLoading: true,
      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0,
      tableData: [],
      dialogVisible: false
    }
  },
  methods: {
    // 项目列表
    getData() {
      this.listLoading = true
      this.tableData = []
      this.$api.applet.getGuideList({
        ...this.form,
        ...this.listQuery
      }).then(res => {
        this.listLoading = false
        if (res.success) {
          if (res.result && res.result.records) {
            debugger
            this.tableData = res.result.records
            this.total = parseInt(res.result.total)
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },

    //封面设置
    uploadPicture() {
      if (this.operation == "view") {
        return
      }
      let option = {
        cropWidth: "315", cropHeight: "290", imgUrl: this.imgUrl
      }
      this.$refs.cropperRef.initCropper(option)
    },

    // 重置查询
    resetForm() {
      this.form = {
        name: '',
      }
      this.listQuery.currentPage = 1
      this.getData()
    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.getData()
    },

    handleView(obj) {
      this.operation = "view"
      this.$api.applet.getGuideDetail({ id: obj.id }).then(res => {
        if (res.success) {
          if (res && res.result) {
            this.dialogVisible = true
            this.addForm = res.result
            if (res.result.pic) {
              this.imgUrl = res.result.pic
            }

          }
        }
      })
    },

    // 新增
    handleAdd(operator, id) {
      this.operation = "add"
      this.dialogVisible = true
    },

    handleEdit(obj) {
      this.operation = "edit"
      this.dialogVisible = true
      this.addForm = JSON.parse(JSON.stringify(obj))
      if (obj.pic) {
        this.imgUrl = `/singleMuseum/attach/getFile?fileId=${obj.pic}`
      }
    },

    // 删除
    handleDelete(obj) {
      this.$common.confirm(
        {
          title: `是否确认删除？`,
          className: 'cus-confirm-375'
        }, () => {
          this.$api.applet.delGuide({ id: obj.id }).then(res => {
            if (res.success) {
              this.$message.success('删除成功')
              this.getData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.getData()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.getData()
    },

    beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2
      const fileName = file.name
      const fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 2MB!',
          type: 'warning'
        })
        return
      }

      if (this.imageTypes.includes(fileType)) {
        return true

      } else {
        this.$message.error(
          '请上传正确的图片类型'
        )
        return
      }
    },

    handleAvatarSuccess(res) {
      if (res.success) {
        this.$message.success('上传成功')
        this.imgUrl = res.result.attPath
        this.addForm.pic = res.result.attId
        if (this.addForm.pic) {
          this.$refs.form.clearValidate('pic');
        }
      } else {
        this.$message.error(res.message)
      }
    },


    onSubmit() {
      const self = this
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let url = "addGuide"
          if (this.addForm.id) {
            url = "updateGuide"
          }
          this.$api.applet[url](this.addForm).then(res => {
            if (res.success) {
              this.$message.success({
                message: this.addForm.id ? '导览修改成功' : '新增导览成功',
                duration: 500,
                onClose() {
                  self.dialogVisible = false
                  self.addForm = {}
                  self.imgUrl = ""
                  self.getData()
                }
              })
            }
          })
        } else {
          return false;
        }
      });
    },

    onCancel() {
      this.dialogVisible = false
      this.addForm = {}
      this.imgUrl = ""
      this.$refs["form"].clearValidate()
    },

    guide(obj) {
      this.$router.push({
        path: '/applet-management/guide-management',
        query: { guideId: obj.id }
      })
    },
    keydown(event) {
      if (event.keyCode == '13') {
        this.getTableList()
      }
    }

    // handleProjectSub(row) {
    //   this.$router.push({
    //     path: '/project/sub',
    //     query: { type: 'task', projectId: row.projectId, projectName: row.projectName }
    //   })
    // },
  },
  created() {
    this.getData()
    window.addEventListener('keyup', this.keydown)

  }
}
</script>

<style lang="scss" scoped>
.guide-wrapper {
  /deep/ .el-form-item {
    .el-form-item__content {
      margin-left: 0 !important;
    }

    &.avatar-uploader-form {
      display: flex;
      flex-direction: column;
      /deep/ .el-form-item__content {
        margin-left: 0 !important;
      }

      .avatar-uploader {
        width: 50%;
        border: 1px dashed #8c939d;
        height: 120px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .el-upload {
          width: 100%;
        }
        .el-icon-plus {
          font-size: 20px;
        }

        .el-upload__text {
          line-height: 1;
        }
        
      }

      .tip-img{
        left: 0;
      }
    }
  }
}
</style>